import { render, staticRenderFns } from "./TagFivePage.vue?vue&type=template&id=5995b36a&scoped=true&"
import script from "./TagFivePage.vue?vue&type=script&lang=js&"
export * from "./TagFivePage.vue?vue&type=script&lang=js&"
import style0 from "./TagFivePage.vue?vue&type=style&index=0&id=5995b36a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5995b36a",
  null
  
)

export default component.exports